<template>
  <div class="page-container">
    <div class="row ml-1">
      <h4 class="mb-4 mr-2">Lista powodów wizyt</h4>
      <div>
        <b-button size="sm" @click="add">
          <span data-feather="plus"></span>
          Dodaj grupę
        </b-button>
      </div>
    </div>
    <b-table
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      show-empty
      stacked="md"
      :current-page="currentPage"
      :per-page="perPage"
      empty-text="Brak grup powodów wizyt"
    >
      <template v-slot:cell(api_keys)="{ item }">
        {{
          JSON.parse(item.api_keys)
            .map(key => allowedApiKeys[key])
            .join(', ')
        }}
      </template>
      <template v-slot:cell(actions)="{ item }">
        <b-button class="btn-primary mr-1" size="sm" @click="edit(item)">Edytuj</b-button>
        <b-button class="btn-danger mr-2" size="sm" @click="remove(item)">Usuń</b-button>
      </template>
    </b-table>

    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'VisitTypes',
  async mounted() {
    const vm = this
    await vm.fetchAllowedApiKeys()
    vm.listGroups()
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'group_name', label: 'Nazwa grupy' },
        { key: 'group_type', label: 'Typ grupy', sortable: true },
        { key: 'api_keys', label: 'Lokalizacje' },
        { key: 'created_at', label: 'Data utworzenia', sortable: true },
        { key: 'updated_at', label: 'Data ostatniej edycji', sortable: true },
        { key: 'actions', label: '' }
      ],
      currentPage: 1,
      totalRows: 0,
      perPage: 6,
      sortBy: '',
      sortDesc: false,
      allowedApiKeys: {}
    }
  },
  watch: {
    items() {
      this.updateUI()
    }
  },
  methods: {
    async fetchAllowedApiKeys() {
      const vm = this
      return vm.$http.post('e-zacma/get-allowed-api-keys').then(response => {
        const apiKeys = response.data
        // eslint-disable-next-line no-restricted-syntax
        for (const key of apiKeys) {
          vm.allowedApiKeys[key.api_key] = key.name
        }
      })
    },
    listGroups() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'list-visit-type-groups')
      vm.$http
        .post('e-zacma/list-visit-type-groups')
        .then(response => {
          vm.items = response.data
        })
        .catch(() => {
          vm.$toast.error({
            message: 'Wystapił błąd podczas próby pobrania listy grup.'
          })
        })
        .then(() => {
          vm.$store.commit('removePageLoaderEvent', 'list-visit-type-groups')
        })
    },
    edit(item) {
      this.$router.push({
        name: 'e-zacma-edit-visit-type-group',
        params: { groupID: item.group_id.toString() }
      })
    },
    add() {
      this.$router.push({ name: 'e-zacma-add-visit-type-group' })
    },
    updateUI() {
      this.totalRows = this.items.length
    },
    remove(item) {
      const vm = this
      vm.$bvModal
        .msgBoxConfirm(
          `Czy na pewno chcesz usunąć typ wizyty "${item.group_name}". Wynik tej operacji jest nieodwracalny.`,
          {
            okVariant: 'danger',
            okTitle: 'Tak',
            cancelTitle: 'Nie',
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(decision => {
          if (decision) {
            vm.$store.commit('addPageLoaderEvent', 'delete-visit-group-type')
            // eslint-disable-next-line camelcase
            const { group_id } = item
            vm.$http
              .post('e-zacma/visit-group-type/remove', { group_id: group_id.toString() })
              .then(() => {
                vm.listGroups()
                vm.$toast.success({
                  message: `Grupa powodu wizyty "${item.group_name}" została skasowana.`
                })
              })
              .catch(e => vm.$error())
              .finally(() => {
                vm.$store.commit('removePageLoaderEvent', 'delete-visit-group-type')
              })
          }
        })
    }
  }
}
</script>

<style scoped></style>
